<nav class="navbar navbar-expand-md navbar-light">
  <div class="navbar-container" [ngClass]="{ container: !isProducerArea, 'container-fluid': isProducerArea }">
    <div class="d-flex justify-content-between align-items-center w-100">
      <app-button
        class="navbar-toggler"
        type="button"
        (click)="toggleNavbar()"
        [attr.aria-expanded]="isNavbarOpen"
        aria-label="Toggle navigation">
        <i [class]="isNavbarOpen ? 'pi pi-times' : 'pi pi-bars'"></i>
      </app-button>

      <a class="navbar-brand link-logo" [routerLink]="['/']">
        <img src="./../../../assets/images/yes7-ticket-logo.png" alt="Logo" height="40" />
      </a>

      @if (isLoggedIn) {
        <div class="mobile-cart">
          <app-button
            class="icon-button"
            type="button"
            styleType="clear-secondary"
            [rounded]="true"
            (btnClick)="goToCart()">
            <i
              class="pi pi-shopping-cart text-3xl"
              pBadge
              [value]="cartItemCount().toString()"
              [badgeDisabled]="cartItemCount() === 0"></i>
          </app-button>
        </div>
        <div class="mobile-notifications">
          <app-navbar-notifications />
        </div>
      }
    </div>
    @if (isNavbarOpen) {
      <app-hamburguer-menu
        [isLoggedIn]="isLoggedIn"
        [isSeller]="isSeller"
        (closeMenu)="toggleNavbar()"
        (loginClick)="openModalLogin()"
        (signUpClick)="openModalSignUp()"
        (myAcountClick)="openModalSignUp()"
        (logoutClick)="logout()" />
    }
    <div class="navbar-collapse" id="navbarNav">
      @if (isProducerArea) {
        <div class="link-producer-area"></div>
      } @else {
        <div class="container-search">
          <app-events-search-input />
          <app-city-dropdown />
        </div>
      }
      @if (isLoggedIn) {
        <div>
          @if (!isProducerArea) {
            <div class="d-flex align-items-center gap-2">
              <app-button icon="pi pi-plus" (click)="openCreateEventsPage()" style="font-size: small"
                >Criar evento</app-button
              >
              @if (isSeller) {
                <app-button icon="pi pi-cart-plus" (click)="goToSellerEvents()" style="font-size: small"
                  >Vender</app-button
                >
              }
            </div>
          }
        </div>

        <app-button
          class="icon-button"
          type="button"
          styleType="clear-secondary"
          [rounded]="true"
          (btnClick)="goToCart()">
          <i
            class="pi pi-shopping-cart text-3xl"
            pBadge
            [value]="cartItemCount().toString()"
            [badgeDisabled]="cartItemCount() === 0"></i>
        </app-button>

        <app-navbar-notifications />

        <div class="dropdown dropstart">
          <app-button
            class="user-button"
            type="button"
            styleType="clear-secondary"
            id="userDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            icon="pi pi-user"
            style="font-size: small">
            {{ name }}
          </app-button>
          <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
            @if (isSeller) {
              <li>
                <a class="dropdown-item d-flex gap-3 align-items-center" routerLink="/seller-events">
                  <i class="pi pi-cart-plus"></i> Vender
                </a>
              </li>
            }
            <li>
              <a class="dropdown-item d-flex gap-3 align-items-center" routerLink="/my-orders">
                <i class="pi pi-ticket"></i> Meus ingressos
              </a>
            </li>

            <li>
              <a class="dropdown-item d-flex gap-3 align-items-center" routerLink="/my-invitations">
                <i class="pi pi-gift"></i> Meus convites
              </a>
            </li>

            <li>
              <a class="dropdown-item d-flex gap-3 align-items-center" routerLink="/favorite-events">
                <i class="pi pi-sparkles"></i> Eventos favoritos
              </a>
            </li>

            <li>
              <a class="dropdown-item d-flex gap-3 align-items-center" routerLink="/followed-producers">
                <i class="pi pi-users"></i> Produtores seguidos
              </a>
            </li>

            <li>
              <a class="dropdown-item d-flex gap-3 align-items-center" routerLink="/my-cards">
                <i class="pi pi-credit-card"></i> Meus cartões
              </a>
            </li>

            <li *appHasRole="['organizer']">
              <a class="dropdown-item d-flex gap-3 align-items-center" routerLink="/producer-area">
                <i class="pi pi-chart-bar"></i> Área do produtor
              </a>
            </li>

            <li>
              <a class="dropdown-item d-flex gap-3 align-items-center" routerLink="/support">
                <i class="pi pi-comments"></i> Ajuda
              </a>
            </li>

            <li>
              <a class="dropdown-item d-flex gap-3 align-items-center" (click)="openModalSignUp()">
                <i class="pi pi-address-book"></i> Meu cadastro
              </a>
            </li>
            <li>
              <a class="dropdown-item d-flex gap-3 align-items-center" (click)="logout()">
                <i class="pi pi-sign-out"></i> Sair
              </a>
            </li>
          </ul>
        </div>
      } @else {
        <div class="navbar-actions">
          <app-button (click)="openModalLogin()" style="font-size: small"> Acessar conta </app-button>
          <app-button (click)="openModalSignUp()" styleType="secondary" style="font-size: small">
            Cadastre-se
          </app-button>
        </div>
      }
      @if (isProducerArea) {
        <div class="sidebar-container">
          <app-sidebar [isProducerArea]="isProducerArea" [navBarMode]="true"></app-sidebar>
        </div>
      }
    </div>
  </div>
</nav>
